#!/usr/bin/env node

import { checkScreenshots } from './check.js';

await checkScreenshots();
